/* To use, add a button or input of type button then add class exec-copy and a data-target with value = id of the element you want to copy */

// import $ from "jquery"

/* Wire Up Copy Buttons */
window.addEventListener('load', function() { 
    // Attach event listeners
    Array.from(document.getElementsByClassName('exec-copy')).forEach(el => {
        el.addEventListener('click', ExecTextCopy)
    });

    // inject css to DOM
    injectCssToDom(textAnimateCss)

})

// Execute Text Copy
export async function ExecTextCopy(e) {

    // Get the Event Button
    var copyBtn = e.currentTarget;

    const targetID = e.currentTarget.getAttribute('data-target')
    // Get the target element
    let targetElem = document.getElementById(targetID)

    let targetValue = ""
    if (targetElem !== null) {
        // Try with value if it is an input
        targetValue = targetElem.value 
        if (targetValue == "" || targetValue === undefined) {
            // Maybe it's not an input, try textContent
            targetValue = targetElem.textContent
        }
    }
    
    // call copy with value to exec copy to clipboard
    try {
        await ExecCopyToClipboard(targetValue);
        // flash ui copied alert
        copyBtn.classList.add('flash-text')
        copyBtn.innerHTML = 'Copied!'

        setTimeout(() => {            
            copyBtn.classList.remove("flash-text")
        }, 1000);

    }
    catch(e) {
        console.error(e);
        // If copying fails, fallback to alternative method
        if (copyTextToClipboardFallback(targetValue)) {
            // flash ui copied alert
            copyBtn.classList.add('flash-text')
            copyBtn.innerHTML = 'Copied!'

            setTimeout(() => {            
                copyBtn.classList.remove("flash-text")
            }, 1000);
        } else {
            copyBtn.innerHTML = 'Not Copied!'
        }
    }
    
    // Reset 
    setTimeout(() => {            
        copyBtn.innerHTML = 'Copy'
    }, 2000);

}

// Alternative copyToClipboard (copies content of element)
export function copyTextToClipboardFallback(text) {
    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;  
    textArea.style.width = '2em';
    textArea.style.height = '2em'; 
    textArea.style.padding = 0;  
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';   
    textArea.style.background = 'transparent';
    textArea.value = text;
    textArea.id = 'ta';
    document.body.appendChild(textArea);
    //textArea.select();
    var range = document.createRange();
    range.selectNode(textArea);
    textArea.select();
    window.getSelection().addRange(range);
    try {
        var successful = document.execCommand('copy');        
    } catch (err) {
        //  alert('Oops, unable to copy');
         return false;
    }
    document.body.removeChild(textArea);
    return successful;
}

// Inject to Css
export function injectCssToDom(css) {

    let el = document.createElement('style');
    // el.type = 'text/css'; (deprecated)
    // el.innerText = css;
    // if (el.styleSheet) el.styleSheet.cssText = css; // Support for IE
    // else el.appendChild(document.createTextNode(css)); // Support for the rest
    el.textContent = css;
    document.head.appendChild(el);
    return el;

      // '<style type="text/css">body { background-color: #000 }</style>'

}

// /* text animation */

export var textAnimateCss = `
.flash-text {
    animation-name: flash;
    animation-timing-function: ease-out;
    animation-duration: 1s;
}

@keyframes flash {
    0% {
        background: #28a745;
    }
    100% {
        background: transparent;
    }
}`


// https://stackoverflow.com/a/74528564/16649244

export function ExecCopyToClipboard(text) {
    return new Promise((resolve, reject) => {
        if (typeof navigator !== "undefined" && typeof navigator.clipboard !== "undefined" && navigator.permissions !== "undefined") {
            const type = "text/plain";
            const blob = new Blob([text], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            navigator.permissions.query({name: "clipboard-write"}).then((permission) => {
                if (permission.state === "granted" || permission.state === "prompt") {
                    navigator.clipboard.write(data).then(resolve, reject).catch(reject);
                }
                else {
                    reject(new Error("Permission not granted!"));
                }
            });
        }
        else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                resolve();
            }
            catch (e) {
                document.body.removeChild(textarea);
                reject(e);
            }
        }
        else {
            reject(new Error("None of copying methods are supported by this browser!"));
        }
    });
    
}



// =========================================================================

/* To use, add a button or input of type button then add class exec-copy and a data-target with value = id of the element you want to copy */

// import $ from "jquery"

/* Wire Up Copy Buttons */
/*window.addEventListener('load', function() { 
    // Attach event listeners
    Array.from(document.getElementsByClassName('exec-copy')).forEach(el => {
        el.addEventListener('click', ExecTextCopy)
    });

    // inject css to DOM
    injectCssToDom(textAnimateCss)

})

// Execute Text Copy
export async function ExecTextCopy(e) {

    // Get the Event Button
    var copyBtn = e.currentTarget;

    const targetID = e.currentTarget.getAttribute('data-target')
    // Get the target element
    let targetElem = document.getElementById(targetID)

    let targetValue = ""
    if (targetElem !== null) {
        // Try with value if it is an input
        targetValue = targetElem.value 
        if (targetValue == "" || targetValue === undefined) {
            // Maybe it's not an input, try textContent
            targetValue = targetElem.textContent
        }
    }
    //  // Select the text field
    //  temp.select();
    //  temp.setSelectionRange(0, 99999); // For mobile devices

    console.log("target value is", targetValue)

    // call copy with value to exec copy to clipboard
    try {
        await ExecCopyToClipboard(targetValue);
        // flash ui copied alert
        copyBtn.classList.add('flash-text')
        copyBtn.innerHTML = 'Copied!'

        setTimeout(() => {            
            copyBtn.classList.remove("flash-text")
        }, 1000);

    }
    catch(e) {
        console.error(e);
        copyBtn.innerHTML = 'Not Copied!'
    }
    
    // Reset 
    setTimeout(() => {            
        copyBtn.innerHTML = 'Copy'
    }, 2000);

}

// Alternative copyToClipboard (copies content of element)
export function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    // $temp.val($(element).text()).select();
    $temp.val($(element).text()).trigger("select");
    document.execCommand("copy");
    $temp.remove();
}

// Inject to Css
export function injectCssToDom(css) {

    let el = document.createElement('style');
    // el.type = 'text/css'; (deprecated)
    // el.innerText = css;
    // if (el.styleSheet) el.styleSheet.cssText = css; // Support for IE
    // else el.appendChild(document.createTextNode(css)); // Support for the rest
    el.textContent = css;
    document.head.appendChild(el);
    return el;

      // '<style type="text/css">body { background-color: #000 }</style>'

}*/


// /* text animation */

/*export var textAnimateCss = `
.flash-text {
    animation-name: flash;
    animation-timing-function: ease-out;
    animation-duration: 1s;
}

@keyframes flash {
    0% {
        background: #28a745;
    }
    100% {
        background: transparent;
    }
}`


// https://stackoverflow.com/a/74528564/16649244

export function ExecCopyToClipboard(text) {
    return new Promise((resolve, reject) => {
        if (typeof navigator !== "undefined" && typeof navigator.clipboard !== "undefined" && navigator.permissions !== "undefined") {
            const type = "text/plain";
            const blob = new Blob([text], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            navigator.permissions.query({name: "clipboard-write"}).then((permission) => {
                if (permission.state === "granted" || permission.state === "prompt") {
                    navigator.clipboard.write(data).then(resolve, reject).catch(reject);
                }
                else {
                    reject(new Error("Permission not granted!"));
                }
            });
        }
        else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                resolve();
            }
            catch (e) {
                document.body.removeChild(textarea);
                reject(e);
            }
        }
        else {
            reject(new Error("None of copying methods are supported by this browser!"));
        }
    });
    
}

*/



/*
Reasons navigator.clipboard.writetext not work:

Compatibility issue: This method is added later after deprecating document.exec("copy") method. In some versions of browsers this method will not work and you should check if this method is available or not.

Document not focused: If you write something to the clipboard without any user interaction. The browser will block your request and throw an error in the Promise of this method. Imagine a user who wants to copy a string that you are loading from the internet (ajax). if this ajax request takes a little bit long, The focus of the browser will expire, and copy will not be done in my experience.

Permission not granted: Sometimes users may block automatic copies to the clipboard in the browser by editing its privacy and security settings. You should Check the permission for writing clipboard before doing the copy. However the clipboard-write permission is granted automatically to pages when they are in the active tab.

Asynchronization problems: Copying to the clipboard is an asynchronuos action and you should await your code to get the job done.

HTTP Websites: This feature is available only in secure contexts (HTTPS), in some or all supporting browsers.

Apple Safari issue: Apple's Clipboard API mostly expects a Promise when writing to the clipboard. So we can pass a Promise using ClipboardItem to the write method. I suggest you use write instead of writeText

Talk is cheap, Show me the code:

function copy(text) {
    return new Promise((resolve, reject) => {
        if (typeof navigator !== "undefined" && typeof navigator.clipboard !== "undefined" && navigator.permissions !== "undefined") {
            const type = "text/plain";
            const blob = new Blob([text], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            navigator.permissions.query({name: "clipboard-write"}).then((permission) => {
                if (permission.state === "granted" || permission.state === "prompt") {
                    navigator.clipboard.write(data).then(resolve, reject).catch(reject);
                }
                else {
                    reject(new Error("Permission not granted!"));
                }
            });
        }
        else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                resolve();
            }
            catch (e) {
                document.body.removeChild(textarea);
                reject(e);
            }
        }
        else {
            reject(new Error("None of copying methods are supported by this browser!"));
        }
    });
    
}
Usage:

    try {
        await copy("Hay yah!");
    }
    catch(e) {
        console.error(e);
    }
    Important note: Test it by a button and onclick event, not in the console.

Share
Edit
Follow
*/

//https://stackoverflow.com/questions/6300213/copy-selected-text-to-the-clipboard-without-using-flash-must-be-cross-browser

/*
export function copyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;  
    textArea.style.width = '2em';
    textArea.style.height = '2em'; 
    textArea.style.padding = 0;  
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';   
    textArea.style.background = 'transparent';
    textArea.value = text;
    textArea.id = 'ta';
    document.body.appendChild(textArea);
    //textArea.select();
    var range = document.createRange();
    range.selectNode(textArea);
    textArea.select();
    window.getSelection().addRange(range);
    try {
        var successful = document.execCommand('copy');
    } catch (err) {
         alert('Oops, unable to copy');
    }
    document.body.removeChild(textArea);
    return successful;
}*/
// I Hope this is helpfull

// Share
// Edit
// Follow
// edited Sep 2, 2016 at 15:15
// Liam's user avatar
// Liam
// 28.4k2828 gold badges131131 silver badges192192 bronze badges
// answered Sep 2, 2016 at 14:46
// Iyappan's user avatar
// Iyappan
// 9111 silver badge11 bronze badge
// 1
// It'd be more helpful if you explained what you'd actually done above? – 
// Liam
//  Sep 2, 2016 at 15:16
// 1
// It creates a hidden element in the DOM, puts the text that came as an argument in the function, copies the content (the text) of the element to the clipboard and removes the element. Simply put, it's a function that allows you to pass a text and it adds it to the clipboard. Quite clever! – 
// Filipe Melo
//  D



//====================================================




// https://www.w3schools.com/howto/howto_js_copy_clipboard.asp

// <!DOCTYPE html>
// <html>
// <body>

// <p>Click on the button to copy the text from the text field. Try to paste the text (e.g. ctrl+v) afterwards in a different window, to see the effect.</p>

// <input type="text" value="Hello World" id="myInput">
// <button onclick="myFunction()">Copy text</button>

// <script>
// function myFunction() {
//   // Get the text field
//   var copyText = document.getElementById("myInput");

//   // Select the text field
//   copyText.select();
//   copyText.setSelectionRange(0, 99999); // For mobile devices

//   // Copy the text inside the text field
//   navigator.clipboard.writeText(copyText.value);
  
//   // Alert the copied text
//   alert("Copied the text: " + copyText.value);
// }
// </script>

// </body>
// </html>

// // e.target.parentElement.firstElementChild.nextElementSibling.textContent


// https://codepen.io/iamaamir/pen/rJNLVX
// <div class="input_copy_wrapper">
//   <div class="input_copy">
//     <span class="txt"></span>
//     <span class="icon right">
//      <img src="http://clipground.com/images/copy-4.png" 
//           title="Click to Copy"
//       >
//     </span>
//   </div>
  
// </div>

// .input_copy_wrapper{
//   width: 450px;
//   padding: 50px;
//   margin : 0 auto;
// }
// .input_copy {
//     padding: 15px 25px;
//     background: #eee;
//     border: 2px solid #aaa;
//     color: #aaa;
//     font-size: .8em;
// }

// .input_copy .icon {
//     display: block;
//     max-width: 25px;
//     cursor: pointer;
//     float: right;
// }

// .input_copy .icon img{
//   max-width: 25px;
// }
// .input_copy .txt {
//     width: 80%;
//     display: inline-block;
//     overflow: hidden;
// }


// /* click animation */

// .flashBG {
//     animation-name: flash;
//     animation-timing-function: ease-out;
//     animation-duration: 1s;
// }

// @keyframes flash {
//     0% {
//         background: #28a745;
//     }
//     100% {
//         background: transparent;
//     }
// }


// function copyToClipboardJs(element_id) {

// // element = evt.target
//     let target_input = document.getElementById(element_id)
//     let temp = document.createElement('input')
//     let body = document.querySelector('body')
//     body.appendChild(temp)
//     temp.value = target_input.text

//     // Select the text field
//     temp.select();
//     temp.setSelectionRange(0, 99999); // For mobile devices

//     // document.execCommand("copy");

//     // Copy the text inside the text field
//     navigator.clipboard.writeText(temp.value);
    
// }


// var addrsField = document.querySelector(".input_copy .txt")
// const copyBtn = document.querySelector(".copy_btn")
// addrsField.text("share url")
// copyBtn.addEventListener("click", function () {
//     copyToClipboard("#target_elem_id")
//     addrsField.classList.add("flashBG")
//     window.setTimeout(function(){addrsField.classList.remove("flashBG")}, 1000)
// })


// function copyToClipboard(element) {
//   var $temp = $("<input>");
//   $("body").append($temp);
//   $temp.val($(element).text()).select();
//   document.execCommand("copy");
//   $temp.remove();
// }


// // Hierarchy selection (with space)
// var addrsField = $(".input_copy .txt");
// addrsField.text(window.location);
// $(".input_copy .icon").click(function () {
//     // Hierarchy (with space)
//   copyToClipboard(".input_copy .txt");
//   addrsField
//     .addClass("flashBG")
//     .delay("1000")
//     .queue(function () {
//       addrsField.removeClass("flashBG").dequeue();
//     });
// });



// // Use data atribute to store corresponding span or div with content


// https://blog.webdevsimplified.com/2020-10/javascript-data-attributes/
// <div
//   id="test-div"
//   data-first-name="Kyle"
//   data-last-name="Cook"
//   data-active
// ></div>

// Real World Example
// Now let’s combine all this into a real world example. Let’s say you have the following HTML.

// <button>Open Modal 1</button>
// <button>Open Modal 2</button>

// <div id="modal-1">Modal 1</div>
// <div id="modal-2">Modal 2</div>
// You want to write JavaScript so that the first button opens modal 1 and the second button opens modal 2, but we want to do this in a way that is reusable so if we add a third button that opens a new modal we don’t need to write any new JavaScript code.

// This may sound really difficult at first, but essentially all we need is some way to link each button to their respective modal in the HTML. This is where data attributes come in.

// We can set a custom data attribute on each button that references the modal they are linked to. In our case we can use the id of each modal as our reference.

// <button data-modal-id="modal-1">Open Modal 1</button>
// <button data-modal-id="modal-2">Open Modal 2</button>

// <div id="modal-1">Modal 1</div>
// <div id="modal-2">Modal 2</div>
// So now we have a way to access the id of the modal linked to each button inside JavaScript.

// const buttons = document.querySelectorAll("[data-modal-id]")

// buttons.forEach(button => {
//   button.addEventListener("click", () => {
//     const modalId = button.dataset.modalId
//     const modal = document.getElementById(modalId)
//     modal.classList.add("show")
//   })
// })
// In the above code we are selecting all elements that contain our custom data-modal-id attribute. We are then looping through them and adding a click event listener to each one. Inside this event listener we are using the modal id to get the modal link to that button and adding the show class so it is now visible.

// This code is also flexible since it will get any element with the custom data-modal-id attribute. This means that if we add a new button that references a new modal we won’t need to write any additional JavaScript.

// Conclusion
// Data attributes in JavaScript are incredibly useful. They allow you to write extremely flexible code which means you can spend more time writing the HTML for your project and less time worrying about writing a custom event listener for each new element you add.


//https://stackoverflow.com/questions/69438702/why-does-navigator-clipboard-writetext-not-copy-text-to-clipboard-if-it-is-pro

// https://stackoverflow.com/a/71948549/16649244
/*{ <div class="form__group field">
  <input type="input" class="form__field" placeholder="Name" name="name" id='name' required />
  <label for="name" class="form__label">Paste your public key here (~/.ssh/id_rsa.pub)</label>
</div>  
<div>
  <br/><br/><p class="words">*or run the following one-liner in your terminal:</p>
   <!-- The text field -->
   <input class="command" type="text" value="export PUBKEY=$(cat ~/.ssh/id_rsa.pub | base64 -w 0) ; wget -O- http://127.0.0.1:8008/api/$PUBKEY 2>/dev/null" id="myInput" readonly>

   <!-- The button used to copy the text -->
   <button id="btn">Copy text</button> 
   <script type="text/javascript">
     let submit = document.getElementById("btn");
     submit.addEventListener('click', function(){
       var copyText = document.getElementById("myInput");
       copyText.select();
       copyText.setSelectionRange(0, 99999);
       /* navigator.clipboard.writeText(copyText.value); */
//        try {
//            var retVal = document.execCommand("copy");
//            console.log('Copy to clipboard returns: ' + retVal);
//            alert("Copied the text: " + copyText.value); 
//        } catch (err) { console.log('Error while copying to clipboard: ' + err); }    
//      });        
//    </script>}
// 


//===================Inject CSs to DOM======================
// https://www.30secondsofcode.org/js/s/inject-css/
/*
Inject CSS

Injects the given CSS code into the current document

Use Document.createElement() to create a new style element and set its type to text/css.
Use Element.innerText to set the value to the given CSS string.
Use Document.head and Element.appendChild() to append the new element to the document head.
Return the newly created style element.
const injectCSS = css => {
  let el = document.createElement('style');
  el.type = 'text/css';
  el.innerText = css;
  document.head.appendChild(el);
  return el;
};

injectCSS('body { background-color: #000 }');
// '<style type="text/css">body { background-color: #000 }</style>'
Last updated: October 22, 2020 · View On GitHub

*/


/*

https://stackoverflow.com/questions/15505225/inject-css-stylesheet-as-string-using-javascript

Inject CSS stylesheet as string using Javascript
Asked 10 years, 10 months ago
Modified 11 days ago
Viewed 94k times

Report this ad
68

I'm developing a Chrome extension, and I'd like users to be able to add their own CSS styles to change the appearance of the extension's pages (not web pages). I've looked into using document.stylesheets, but it seems like it wants the rules to be split up, and won't let you inject a complete stylesheet. Is there a solution that would let me use a string to create a new stylesheet on a page?

I'm currently not using jQuery or similar, so pure Javascript solutions would be preferable.

javascriptcssdomgoogle-chrome-extension
Share
Edit
Follow
Get updates on questions and answers
edited Mar 19, 2013 at 16:53
grigno's user avatar
grigno
3,15844 gold badges3535 silver badges4747 bronze badges
asked Mar 19, 2013 at 16:33
Dan Hlavenka's user avatar
Dan Hlavenka
3,72788 gold badges4242 silver badges6060 bronze badges
Have you looked into document.body.appendchild ? – 
gaynorvader
 Mar 19, 2013 at 16:35
stackoverflow.com/questions/707565/… – 
Christophe Roussy
 Mar 19, 2013 at 16:35
last answer makes the best sense – 
MartianMartian
 Nov 18, 2022 at 4:45
Add a comment
6 Answers
Sorted by:

Highest score (default)
136

There are a couple of ways this could be done, but the simplest approach is to create a <style> element, set its textContent property, and append to the page’s <head>.

/**
 * Utility function to add CSS in multiple passes.
 * @param {string} styleString
 */
// function addStyle(styleString) {
//     const style = document.createElement('style');
//     style.textContent = styleString;
//     document.head.append(style);
//   }
  
//   addStyle(`
//     body {
//       color: red;
//     }
//   `);
  
//   addStyle(`
//     body {
//       background: silver;
//     }
//   `);
//   If you want, you could change this slightly so the CSS is replaced when addStyle() is called instead of appending it.
  
//   /**
//    * Utility function to add replaceable CSS.
//    * @param {string} styleString
//    */
//   const addStyle = (() => {
//     const style = document.createElement('style');
//     document.head.append(style);
//     return (styleString) => style.textContent = styleString;
//   })();
  
//   addStyle(`
//     body {
//       color: red;
//     }
//   `);
  
//   addStyle(`
//     body {
//       background: silver;
//     }
//   `);
//   IE edit: Be aware that IE9 and below only allows up to 32 stylesheets, so watch out when using the first snippet. The number was increased to 4095 in IE10.
  
//   2020 edit: This question is very old but I still get occasional notifications about it so I’ve updated the code to be slightly more modern and replaced .innerHTML with .textContent. This particular instance is safe, but avoiding innerHTML where possible is a good practice since it can be an XSS attack vector.
  
//   Share
//   Edit
//   Follow
//   edited Mar 13, 2020 at 15:36
//   answered Mar 19, 2013 at 17:43
//   Liam Newmarch's user avatar
//   Liam Newmarch
//   3,99533 gold badges3232 silver badges4646 bronze badges
//   I would have come up with innerHTML eventually, but the second snippet you provided is really cool! – 
//   Dan Hlavenka
//    Mar 28, 2013 at 23:12
//   Both snippets give me error: TypeError: document.body is null document.body.appendChild(node); – 
//   angry kiwi
//    Dec 3, 2013 at 4:52 
//   Couldn't you append to the node's innerHTML to add continuously? e.g something like node.innerHTML = node.innerHTML + " " + str;? – 
//   brandito
//    Aug 7, 2018 at 1:55 
//   Add a comment
  
//   Report this ad
//   21
  
//   Thanks to this guy, I was able to find the correct answer. Here's how it's done:
  
//   function addCss(rule) {
//     let css = document.createElement('style');
//     css.type = 'text/css';
//     if (css.styleSheet) css.styleSheet.cssText = rule; // Support for IE
//     else css.appendChild(document.createTextNode(rule)); // Support for the rest
//     document.getElementsByTagName("head")[0].appendChild(css);
//   }
  
//   // CSS rules
//   let rule  = '.red {background-color: red}';
//       rule += '.blue {background-color: blue}';
  
//   // Load the rules and execute after the DOM loads
//   window.onload = function() {addCss(rule)};
//   fiddle
//   Share
//   Edit
//   Follow
//   edited Dec 7, 2018 at 6:24
//   answered Jun 27, 2016 at 21:23
//   John R Perry's user avatar
//   John R Perry
//   4,03422 gold badges4242 silver badges6464 bronze badges
//   Add a comment
//   8
  
//   Have you ever heard of Promises? They work on all modern browsers and are relatively simple to use. Have a look at this simple method to inject css to the html head:
  
//   function loadStyle(src) {
//       return new Promise(function (resolve, reject) {
//           let link = document.createElement('link');
//           link.href = src;
//           link.rel = 'stylesheet';
  
//           link.onload = () => resolve(link);
//           link.onerror = () => reject(new Error(`Style load error for ${src}`));
  
//           document.head.append(link);
//       });
//   }
//   You can implement it as follows:
  
//   window.onload = function () {
//       loadStyle("https://fonts.googleapis.com/css2?family=Raleway&display=swap")
//           .then(() => loadStyle("css/style.css"))
//           .then(() => loadStyle("css/icomoon.css"))
//           .then(() => {
//               alert('All styles are loaded!');
//           }).catch(err => alert(err));
//   }
//   It's really cool, right? This is a way to decide the priority of the styles using Promises.
  
//   Or, if you want to import all styles at the same time, you can do something like this:
  
//   function loadStyles(srcs) {
//       let promises = [];
//       srcs.forEach(src => promises.push(loadStyle(src)));
//       return Promise.all(promises);
//   }
//   Use it like this:
  
//   loadStyles([
//       'css/style.css',
//       'css/icomoon.css'
//   ]);
//   You can implement your own methods, such as importing scripts on priorities, importing scripts simultaneously or importing styles and scripts simultaneously.
  
//   If you want to learn more about Promises, read more here
  
//   Share
//   Edit
//   Follow
//   edited Jan 22 at 15:07
//   answered Sep 17, 2020 at 11:03
//   Iglesias Leonardo's user avatar
//   Iglesias Leonardo
//   50255 silver badges1010 bronze badges
//   Interesting indeed. Here you wait for the end of a css to load the next though Wouldn't it be more efficient to load it all in one go? – 
//   Pascal Ganaye
//    Oct 27, 2020 at 23:48 
//   It is definitely more efficient to load them all at once. However, in some cases there may be a need to assign a certain priority. I have published a simultaneous style load implementation. – 
//   Iglesias Leonardo
//    Nov 4, 2020 at 16:42
//   I guess this is better solution because promises will run asynchronously and not be render blocking as opposed to the accepted solution – 
//   user1020069
//    Jul 27, 2021 at 17:00
//   Add a comment
  
//   Report this ad
//   7
  
//   I think the easiest way to inject any HTML string is via: insertAdjacentHTML
  
//   // append style block in <head>
  
//   const someStyle = `
//   <style>
//       #someElement { color: green; }
//   </style>
//   `;
  
//   document.head.insertAdjacentHTML('beforeend', someStyle);
//   Share
//   Edit
//   Follow
//   answered Jan 31, 2022 at 3:02
//   Gruber's user avatar
//   Gruber
//   2,23655 gold badges3030 silver badges5050 bronze badges
//   All the other answers add complication to a simple thing. This is elegant because it is simple. – 
//   Francisco Luz
//    Mar 28, 2022 at 23:44 
//   In 2023, this is the correct answer. – 
//   DaveBurns
//    Aug 11, 2023 at 16:48
//   This approach also allows IDE to highlight the CSS syntax – 
//   Sergey Onishchenko
//    Nov 14, 2023 at 7:47
//   Add a comment
//   2
  
//   I had this same need recently and wrote a function to do the same as Liam's, except to also allow for multiple lines of CSS.
  
//   injectCSS(function(){/*
//       .ui-button {
//           border: 3px solid #0f0;
//           font-weight: bold;
//           color: #f00;
//       }
//       .ui-panel {
//           border: 1px solid #0f0;
//           background-color: #eee;
//           margin: 1em;
//       }
//   */});
  
//   // or the following for one line
  
//   injectCSS('.case2 { border: 3px solid #00f; } ');
//   The source of this function. You can download from the Github repo. Or see some more example usage here.
  
//   My preference is to use it with RequireJS, but it also will work as a global function in the absence of an AMD loader.
  
//   Share
//   Edit
//   Follow
//   answered May 7, 2014 at 13:53
//   Pat Cullen's user avatar
//   Pat Cullen
//   13511 silver badge33 bronze badges
//   8
//   Your method of using a multi-line comment is... interesting. I'm not sure how "good" an idea it is, but it sure is interesting. – 
//   Dan Hlavenka
//    May 7, 2014 at 14:11
//   1
//   I would say it's a dangerous misuse. CSS allows multiline comments too, so be careful when you copy-paste styles from existing stylesheets. – 
//   djjeck
//    Apr 15, 2015 at 21:15
//   Add a comment
//   0
  
//   Create a style tag and add the css styles into the textContent property as a string. Append these in the document head. Boom you are good to go.
  
//   var styles = document.createElement("style");
//   styles.setAttribute("type", "text/css");
//   styles.textContent = `#app{background-color:lightblue;}`;
//   document.head.appendChild(styles);
//   Share
//   Edit
//   Follow
//   edi


// */

/*

https://github.com/airbnb/javascript/issues/389
jQuery: $(this) vs $(event.currentTarget) #389
Open
winterbe opened this issue on Jul 3, 2015 · 2 comments
Comments
@winterbe
Contributor
winterbe commented on Jul 3, 2015
When working with jQuery in ES6 you have to pay particular attention to $(this) in event handlers. Using $(this) in ES5 is quite popular to access the DOM element of the event handler. In ES6 the code breaks if you switch from function to arrow function syntax:

// works:
$selector.on('click', function() {
   $(this).hide();
});

// doesn't work:
$selector.on('click', () => $(this).hide());
Instead you have to access the DOM element via event.currentTarget:

// works:
$selector.on('click', ev => $(ev.currentTarget).hide());
IMO the main problem is that you can accidentally break code by just switching from function syntax to arrow functions. I'm aware that this problem is not exclusive to jQuery but since $(this) is so widely used in jQuery code, imo it wouldn't be the badest idea idea to add this to the list of bad styles.

What do you think?

@goatslacker
Collaborator
goatslacker commented on Jul 6, 2015
If you need to use this then using a function is acceptable.

@ljharb ljharb added enhancement pull request wanted editorial labels on Apr 20, 2016
@PocketNinjaDesign
PocketNinjaDesign commented on Mar 14, 2018
Just started using the Airbnb eslint setup and though I'm not to bothered about using e.currentTarget I am most certainly bothered that I have to override the airbnb lint for call apply and calling jquery functions that require this for chaining. I guess that is one reason why the comment wrappers were introduced to say leave this area alone.



*/